import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
    localStorage.removeItem("userid");
    localStorage.removeItem("userRoll");
    navigate("/login");
    window.location.reload();
  }, [navigate]);

  return null; // No UI
}

export default Logout;
